class NBMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.megamenuTrigger = this.querySelector('.nb-megamenu-trigger');
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter(event) {
    if (!this.megamenuTrigger) return;
    const details = this.megamenuTrigger.closest('details');
    if (details && !details.hasAttribute('open')) {
      details.setAttribute('open', '');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }

  onMouseLeave(event) {
    if (!this.megamenuTrigger) return;
    const details = this.megamenuTrigger.closest('details');
    if (details && details.hasAttribute('open')) {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  }
}

customElements.define('nb-megamenu', NBMegaMenu);
